



















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Action, State} from "vuex-class";
import AccountDataAES from "@/util/accountDataAES";
import store from "@/store";
import Base64Encoder from "@/util/base64encoder";
import KeyUtility from "@/util/keyUtility";
import dayjs from "@/util/dayjs";
import Letterbox from "@/models/Letterbox";
import featureFlags from "@/util/featureFlags";

@Component
export default class LetterboxListItem extends Vue {

  @Prop(Object) letterbox!: Letterbox;
  @State(state => state.account.masterKey) masterKey!: CryptoKey;
  @Action deleteLetterbox!: (id: string) => Promise<void>;
  decryptedLetterbox: Letterbox | null = null;
  openLink: string = "";

  get formattedCreationDate(): string {
    const date = dayjs(this.letterbox.created);
    return date.format('dddd, DD. MMMM YYYY [um] HH:mm');
  }

  get contentCount(): string {
    if (this.letterbox && this.letterbox.uploads && this.letterbox.uploads.length) {
      return this.letterbox.uploads.length + "";
    } else {
      return "keine";
    }
  }

  get message(): string {
    if (this.decryptedLetterbox) {
      return this.decryptedLetterbox.message;
    } else {
      return "Nachricht wird entschlüsselt";
    }
  }

  get name(): string {
    if (this.decryptedLetterbox) {
      return this.decryptedLetterbox.name;
    } else {
      return "Name wird entschlüsselt";
    }
  }

  async getLetterboxKeyAsBase64(): Promise<string> {
    const accountEncryption: AccountDataAES = await AccountDataAES.fromAccountData(store.state.account.masterKey, store.state.account.accountData);
    const iv: Uint8Array = Base64Encoder.stringToBytes(this.letterbox.secretEncryptedIv);
    return await accountEncryption.decryptStringFromBase64Encoded(this.letterbox.secretEncrypted, iv);
  }

  async getOpenLinkOfLetterbox(): Promise<void> {
    const baseUrl: string = featureFlags.frontendBaseUrl + '/letterbox/';
    const uriKey = encodeURIComponent(await this.getLetterboxKeyAsBase64());
    this.openLink = baseUrl + this.letterbox.id + '/download#' + uriKey;
  }

  async copyLinkToClipboard(): Promise<void> {
    const baseUrl: string = featureFlags.frontendBaseUrl + '/letterbox/';
    const uriKey = encodeURIComponent(await this.getLetterboxKeyAsBase64());
    const copyText: HTMLInputElement = document.createElement("input");
    document.body.appendChild(copyText);
    copyText.value = baseUrl + this.letterbox.uploadKey + '/upload#' + uriKey;
    copyText.select();
    document.execCommand("copy");
    document.body.removeChild(copyText);
    this.$toast.success('Link wurde in die Zwischenablage kopiert.');
  }

  async askForDelete(): Promise<void> {
    const willDelete: boolean | null = await this.$swal({
      title: "Sind sie sicher?",
      text: "Wenn Du den Briefkasten löscht, gibt es keine Möglicheit, dort etwas hochzuladen und alle Dateien im Briefkasten werdne gelöscht!",
      icon: "warning",
      buttons: ["Nein, zurück", "Ja, Löschen"],
      dangerMode: true,
    });

    if (willDelete) {
      try {
        await this.deleteLetterbox(this.letterbox.id);
        this.$toast.success("Briefkasten gelöscht");
      } catch (e) {
        this.$toast.error("Briefkasten konnte nicht gelöscht werden");
      }
    }
  }

  @Watch('letterbox')
  async encryptValuesIntoComponent(): Promise<void> {
    const letterboxKeyBase64: string = await this.getLetterboxKeyAsBase64();
    const letterboxKey: CryptoKey = await KeyUtility.loadKeyFromBase64(letterboxKeyBase64);
    const decryptedLetterbox: Letterbox = await (Letterbox.from(this.letterbox).getDecrypted(letterboxKey));
    this.decryptedLetterbox = decryptedLetterbox;
  }

  created(): void {
    this.encryptValuesIntoComponent();
    this.getOpenLinkOfLetterbox();
  }




}
